// File: frontend/src/pages/StudentLoginPage.jsx

import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI } from '../services/api';

export default function StudentLoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { setSession } = useAuth();  // We'll still use the main login function from context
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const loginPromise = authAPI.studentLogin(username, password);

        toast.promise(loginPromise, {
            loading: 'Logging in...',
            success: (data) => {
                // THE FIX: We call setSession with the data from the student login
                setSession(data.token, data.user);
                navigate('/student/dashboard'); // Redirect to the student dashboard
                return <b>Welcome!</b>;
            },
            error: (err) => <b>{err.response?.data?.error || 'Login failed.'}</b>
        });
    };

    return (
        <div className="bg-slate-100 min-h-screen flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-slate-200">
                <div className="mb-4">
                    <Link to="/" className="text-xs font-semibold text-slate-500 hover:text-emerald-600 inline-flex items-center gap-1 transition-colors">
                        &larr; Back to Home (回首頁)
                    </Link>
                </div>
                <div className="text-center mb-6">
                    <img 
                        src="/logo192.png" 
                        alt="Irie Roots Logo" 
                        className="w-14 h-14 rounded-2xl object-cover mx-auto mb-2.5 shadow-md shadow-emerald-500/20 border border-slate-100" 
                    />
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Student & Parent Portal</h2>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">學生與家長專區 (愛瑞美語)</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700 dark:text-gray-300 mb-2">Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 dark:text-gray-300 mb-2">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md"
                            required
                        />
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700">
                        Login
                    </button>
                </form>
                <div className="text-center mt-4">
                    <Link to="/login" className="text-sm text-blue-600 hover:underline">Are you a teacher or admin?</Link>
                </div>
            </div>
        </div>
    );
}